import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Modal, Container, Row, Col, Button, Alert } from "react-bootstrap";
import { retornaCpo, setMemoria } from "../../tools/auxiliar";
import api from "../../services/api";

export default function ParticipanteIdentifica({ history }) {
  const [modalShow, setModalShow] = useState(true);
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem] = useState("danger");
  const [pessoa, setPessoa] = useState([]);
  const { consulta_id } = useParams();
  const [idAudiencia] = useState(consulta_id);
  const [chave, setChave] = useState("");

  useEffect(() => {
    async function loadPessoa() {
      if (email && email.indexOf("@") > 1) {
        const response = await api.get(`/api/pessoa/${email}/publico`);
        setPessoa(response.data[0]);
      }
    }
    loadPessoa();
  }, [email]);

  useEffect(() => {
    async function loadChave() {
      const sistema = '***consulta_publica***';
      const response = await api.get('/api/configuracao', {
        headers: { sistema }
      });
      setChave(response.data[0].NO_EMAIL);
    }
    loadChave();
  }, [email]);

  function handleAutentica(){
    setMemoria("","",false);
    setMensagem("");
    if (email.length < 4 || senha.length < 4 || !pessoa ){
      setMensagem("Identificação invalida!");
    } else {
      const senhaTratada = retornaCpo(pessoa.DS_SENHA, chave);
      if (senha !== senhaTratada){
        setMensagem("Identificação Inválida!");
      } else {
        setMemoria(pessoa.NO_PESSOA,email,true);
        setModalShow(false);
        window.location=(`/Consulta/${idAudiencia}/Contribuicao/`);  
      }
    }
  }
  function handleCancelar() {
      setModalShow(false);
      history.push(`/Consulta/${idAudiencia}`);
  }
  function handleNovo() {
    setModalShow(false);
    history.push(`/Consulta/${idAudiencia}/NovoParticipante`);
  }
  function handleSenha() {
    setModalShow(false);
    history.push(`/Consulta/${idAudiencia}/EsqueciSenha`);
  }
  return (
    <>
      <Modal show={modalShow} onHide={() => setModalShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter-lg"  animation={false}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Identificação do Participante
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
          <form id="form">
              <Row className="show-grid">
                <Col sm={2}>
                    <label htmlFor="email">E-mail:</label>
                </Col>
                <Col sm={10}>
                    <input
                        type="email"
                        id="email"
                        className="Requerido"
                        placeholder="Informe e-mail"
                        email={email}
                        onChange={event => setEmail(event.target.value)}
                    />
                </Col>
              </Row>
              <Row className="show-grid">
                <Col sm={2}>
                    <label htmlFor="senha">Senha:</label>
                </Col>
                <Col sm={10}>
                    <input
                        type="password"
                        id="senha"
                        className="Requerido"
                        placeholder="Informe sua senha"
                        value={senha}
                        onChange={event =>setSenha(event.target.value)}
                        autoComplete="password"
                    />
                </Col>
              </Row>
              <Row className={mensagem ? "mostrar" : "naoMostrar"}>
                <Col sm="12">
                  <Alert variant={tipoMensagem}>
                      {mensagem}
                  </Alert>
                </Col>
              </Row>
              <Row>
                <Col sm="12" className="observacao">
                  - Caso ainda não tenha se inscrito como Participante escolha "Novo participante".<br />
                  - Caso não se lembre de sua senha, utilize "Esqueci minha senha".
                </Col>
              </Row>
            </form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelar}>Cancelar</Button>
          <Button variant="info" onClick={handleSenha}>Esqueci minha senha</Button>
          <Button variant="primary" onClick={handleNovo}>Novo Participante</Button>
          <Button variant="success" onClick={handleAutentica}>Enviar</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}